/**
 * 与 Layout.js 底部 Tab 一致（height: 56），fixed 底栏需 bottom: H5_TAB_BAR_PX，避免被 Tab 遮挡。
 */
export const H5_TAB_BAR_PX = 56;
